import { DebounceSelect } from "@/components/antd/form/DebounceSelect"
import { SearchBarType } from "@/modules/edu/pages/operation/work-time/type"
import { API } from "@/network/http"
import { SearchOutlined } from "@ant-design/icons"
import { Form } from "antd"
import { memo } from "react"

const SubjectSearch: React.FC<SearchBarType> = ({ style, name, label }) => {
  const getListSubject = async (searchValue?: string) => {
    const response = await API.subjects.subjectControllerGetMany({ name: searchValue })
    return (
      response?.data?.data?.map((item: any) => ({
        key: item?._id,
        value: item?._id,
        name: item?.name,
      })) || []
    )
  }

  return (
    <Form.Item name={name} label={label} style={{ marginBottom: "12px" }}>
      <DebounceSelect
        mode="multiple"
        placeholder={
          <>
            <SearchOutlined /> Môn học{" "}
          </>
        }
        fetchOptions={getListSubject}
      />
    </Form.Item>
  )
}

export default memo(SubjectSearch)
